import React from 'react';
import { useIntl } from 'react-intl';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { Alignment, Button, Icon, JustifyContents } from 'tacho-ui';
import { TachoEditModalTitle } from '../TachoModal/TachoEditTitle';
import { TachoModalHeader } from '../TachoModal/TachoModalHeader';
import styles from './styles.module.scss';

interface TachoInformationModalProps {
    id: string;
    modalTitle: string | JSX.Element;
    modalBody: string | JSX.Element;
    isOpen: boolean;
    size?: string;
    icon?: Icon;
    supressTranslateModalBody?: boolean;
    onToggle: () => void;
}

export const TachoInformationModal = (props: TachoInformationModalProps) => {
    const { formatMessage } = useIntl();
    return (
        <>
            <Modal id={props.id} size={props.size} isOpen={props.isOpen} toggle={props.onToggle} backdrop="static">
                <TachoModalHeader
                    titleHorizontalLine={false}
                    title={<TachoEditModalTitle titleToTranslation={props.modalTitle} icon={props.icon || Icon.Information} />}
                    onToggle={props.onToggle}
                />
                <ModalBody className={styles.modalBody}>
                    {props.modalBody && !props.supressTranslateModalBody && typeof props.modalBody === 'string' ? (
                        formatMessage({ id: props.modalBody })
                    ) : (
                        <>{props.modalBody}</>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button
                        justify={JustifyContents.center}
                        align={Alignment.center}
                        gap={4}
                        text={formatMessage({ id: 'sharedComponentsClose' })}
                        icon={Icon.Clear}
                        className="secondary"
                        onClick={props.onToggle}
                    />
                </ModalFooter>
            </Modal>
        </>
    );
};
